// feedRowUID - uid from FeedRow model

export const emptyExtraBlockInfoObject = { entity_type: '', data: [], id: '' };
const emptyFeedRowObject = {
  extraBlockinfo: emptyExtraBlockInfoObject
};

// eslint-disable-next-line import/prefer-default-export
export const getFeedRow = (state, feedRowUID) =>
  state.feedrows.data[feedRowUID] || emptyFeedRowObject;
